import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TabViewModule } from 'primeng/tabview';
import { MultiSelectModule } from 'primeng/multiselect';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { TableModule } from 'primeng/table';
import { DropdownModule } from 'primeng/dropdown';
import { HomeFlowdy2DocsComponent } from './home.flowdy2.docs.component';

@NgModule({
  declarations: [
    HomeFlowdy2DocsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    TabViewModule,
    MultiSelectModule,
    ButtonModule,
    TooltipModule,
    TableModule,
    DropdownModule
  ],
  exports: [
    HomeFlowdy2DocsComponent
  ]
})
export class HomeFlowdy2DocsModule { } 